import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ProximityUser } from '@models';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

export interface UserFrmDialogData {
  user: ProximityUser;
  updateUrl?: string;
  canRequestEdit?: boolean;
}

@Component({
  template: `
    <div class="w-full overflow-hidden">
      <!-- extra width because prox-user-frm only has 75% width -->
      <div style="width: 133%">
        <prox-user-frm [proximityUser]="data.user" [isReadOnly]="true"></prox-user-frm>
      </div>

      <div class="mt-3 flex">
        <button (click)="close()" pButton type="button" icon="pi pi-times" label="Close" class="p-button-raised p-button-primary"></button>
        <div class="grow"></div>
        <button
          *ngIf="!data.updateUrl && data.canRequestEdit"
          pButton
          (click)="requestEdit()"
          icon="pi pi-pencil"
          label="Edit My Profile"
          class="p-button-raised p-button-primary"
        ></button>
        <button
          *ngIf="!!data.updateUrl"
          pButton
          [routerLink]="data.updateUrl"
          (click)="close()"
          icon="pi pi-pencil"
          label="Go to edit page"
          class="p-button-raised p-button-primary"
        ></button>
      </div>
    </div>
  `,
  standalone: false,
})
export class UserFrmDialogComponent {
  data!: UserFrmDialogData;

  static config = {
    contentStyle: { overflow: 'auto', height: '370px' },
    modal: true,
    focusOnShow: false,
    width: '700px',
  };

  constructor(
    dialogConfig: DynamicDialogConfig<UserFrmDialogData>,
    private ref: DynamicDialogRef,
  ) {
    this.data = dialogConfig.data as any;
  }

  close() {
    this.ref.close();
  }

  requestEdit() {
    this.ref.close('requestEdit');
  }
}
